import { ApiRewardsProgram } from '@api/interfaces/ApiRewardsProgram';
import { ProgramStatus } from '@shared/enums/ProgramStatus';
import { RewardsProgramType } from '@shared/enums/RewardsProgramType';
import { getJsDateFromString, getProgramStatus } from '@shared/utilities';
import { DateTime } from 'luxon';

export const isCategoryHurdleInBushels = (name: string) => (
  ['Grain (Soy)', 'Grain (Corn)', 'Feed'].includes(name)
);

const ProgramStatusPriority: Record<ProgramStatus, number> = {
  [ProgramStatus.Active]: 0,
  [ProgramStatus.Future]: 1,
  [ProgramStatus.Expired]: 2,
};

// Orders programs Active -> Future -> Expired, with ties (e.g. multiple
// Expired programs) broken by end date descending.
export const compareProgramsByStatusThenEndDate = (
  a: ApiRewardsProgram,
  b: ApiRewardsProgram,
) => {
  const statusA = getProgramStatus(a);
  const statusB = getProgramStatus(b);
  const priorityA = statusA ? ProgramStatusPriority[statusA] : Infinity;
  const priorityB = statusB ? ProgramStatusPriority[statusB] : Infinity;
  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }
  return new Date(b.endDate).getTime() - new Date(a.endDate).getTime();
};

// Picks the most relevant program of the given type: Active first, then
// Future, then the most recently Expired (matching the card list order).
export const getMostRelevantProgram = (
  programs: ApiRewardsProgram[] | undefined,
  type: RewardsProgramType,
) => (
  programs
    ?.filter((program) => program.type === type)
    .sort(compareProgramsByStatusThenEndDate)[0]
);

export const getProgramPeriodText = (program: ApiRewardsProgram) => {
  const startJsDate = program.startDate
    ? getJsDateFromString(program.startDate)
    : undefined;
  const endJsDate = program.endDate
    ? getJsDateFromString(program.endDate)
    : undefined;
  if (!startJsDate || !endJsDate) {
    return '';
  }
  const startDateText = DateTime.fromJSDate(startJsDate).toFormat('MMM d, yyyy');
  const endDateText = DateTime.fromJSDate(endJsDate).toFormat('MMM d, yyyy');
  return `${startDateText}–${endDateText}`;
};
